'use strict';

/* eslint-disable no-inner-declarations */

// Adds or removes 'active' class on email input focus/blur
function initNewsletterInputFocus() {
    const $wrappers = $('.js-home-email-signup, .popin-email-signup');
    const $inputs = $('#hpEmailSignUp, #popinEmailSignUp');

    $inputs.each(function (index) {
        const $input = $(this);
        const $wrapper = $wrappers.eq(index);

        $input.on('focus', function () {
            $wrapper.addClass('active');
        });

        $(document).on('mousedown', function (e) {
            const isClickOutside = !$wrapper[0].contains(e.target);
            const isInputEmpty = !$input.val().trim();

            if (isClickOutside && isInputEmpty) {
                $wrapper.removeClass('active');
            }
        });
    });
}

// Enables the submit button only if the email is valid and RGPD checkbox is checked
function bindEmailInputValidation() {
    const $email = $('#hpEmailSignUp');

    if ($email.length) {
        const $submit = $('.js-home-email-signup .newsletter-submit');
        const emailRegex = /^[\w\-\.]+@([\w\-]+\.)+[a-zA-Z]{2,}$/;
        const $clearBtn = $('#clearBtn');

        function validateForm() {
            const isEmailValid = emailRegex.test($email.val().trim());

            $submit.prop('disabled', !isEmailValid);
            $submit.toggleClass('disabled', !isEmailValid);
            $submit.attr('aria-disabled', !isEmailValid);
        }

        $email.on('input', function () {
            const isEmailValid = emailRegex.test($email.val().trim());

            validateForm();

            $clearBtn.show();
            if (isEmailValid) {
                $clearBtn.hide();
            } else {
                $clearBtn.show();
            }
        });

        $clearBtn.on('click', function () {
            $email.val('');
            $(this).hide();
            $email.focus();
            validateForm();
        });

        // Call once on load in case value is already set (e.g. authenticated user)
        validateForm();
    }
}


// Submits the newsletter form and handles validation + display logic
function handleNewsletterFormSubmit() {
    $('.js-home-email-signup .newsletter-submit').on('click', function (e) {
        e.preventDefault();

        var $error = $('.js-home-email-signup .invalid-feedback');
        var $errorValidateRGPD = $('#checkbox-hpEmailSignUp-error');
        var $success = $('.js-home-email-signup .success-message');
        var $form = $('.js-home-email-signup .js-newsletter-signup');
        var email = $('#hpEmailSignUp');
        var filter = /^[\w\-\.]+@([\w\-]+\.)+[a-zA-Z]{2,}$/;

        $error.hide();
        $success.hide();

        if (email.val().trim() !== '') {
            if (!filter.test(email.val())) {
                $error.show().addClass('d-block').attr('role', 'alert');
            } else {
                if ($('#checkbok-hpEmailSignUp').length === 0 || $('#checkbok-hpEmailSignUp').val() === '1') {
                    $errorValidateRGPD.hide().attr('role', '');
                    $('.js-newsletter-signup .newsletter-submit').attr('disabled', true).attr('aria-disabled', true);

                    $.ajax({
                        url: $form.data('action'),
                        method: 'POST',
                        data: $form.serialize(),
                        success: function () {
                            $('.footer-newsletter__checkbox').addClass('d-none');
                            $('.newsletter-submit').addClass('d-none');
                            $success.show().addClass('isOptin');
                            email.addClass('footer-newsletter__input--disabled');
                            email.attr('disabled', true).attr('aria-disabled', true);

                            dataLayer.push({
                                newsletter_type: 'Mail',
                                event: 'newsletter_subscription'
                            });
                        },
                        error: function () {
                            // handle error if needed
                        }
                    });
                } else {
                    $errorValidateRGPD.show().attr('role', 'alert');
                }
            }
        } else {
            $error.show();
        }
    });
}

// Validates email input in the popin on change
function bindPopinEmailValidation() {
    const $popin = $('.popin-email-signup');
    const emailRegex = /^[\w\-\.]+@([\w\-]+\.)+[a-zA-Z]{2,}$/;

    $popin.find('.new-email-input').on('keyup change keypress', function () {
        const val = $(this).val();
        $popin.find('#hpEmailSignUp-error-empty, #hpEmailSignUp-error').hide();

        if (emailRegex.test(val) || val.trim() === '') {
            $popin.find('#hpEmailSignUp-error').removeClass('d-block').addClass('d-none');
        } else {
            $popin.find('#hpEmailSignUp-error').addClass('d-block').removeClass('d-none');
        }
    });

    $popin.find("#checkbok-hpEmailSignUp-popin, #label-checkbok-hpEmailSignUp-popin").on('click', function () {
        if ($(this).is(":checked")) {
            $('#checkbox-hpEmailSignUp-popin-error').hide();
        }
    });
}

// Validates phone input in the popin on change
function bindPopinPhoneValidation() {
    const $popin = $('.popin-email-signup');
    const phoneRegex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;

    $popin.find('.new-phone-input').on('keypress', e => {
        const charCode = e.which || e.keyCode;
        if (charCode < 48 || charCode > 57) e.preventDefault();
    });

    $popin.find('.new-phone-input').on('paste', e => {
        const paste = (e.originalEvent || e).clipboardData.getData('text');
        if (!/^\d+$/.test(paste)) e.preventDefault();
    });

    $popin.find('.new-phone-input').on('keyup change input', function () {
        const val = $(this).val();
        $popin.find('#hpPhoneSignUp-error-empty, #hpPhoneSignUp-error').hide();

        if (phoneRegex.test(val)) {
            $popin.find('#hpPhoneSignUp-error, #hpPhoneSignUp-error-empty')
                .removeClass('d-block').addClass('d-none');
        } else {
            if (val.trim() !== '') {
                $popin.find('#hpPhoneSignUp-error').addClass('d-block').removeClass('d-none');
            } else {
                $popin.find('#hpPhoneSignUp-error').removeClass('d-block').addClass('d-none');
            }
        }
    });
}

// Handles the newsletter pop-in subscription success
function successNewsletterSubscribe($form, $errorValidateRGPD_popin, $before_success, $after_success) {
    $errorValidateRGPD_popin.hide();
    $('.popin-email-signup #hpEmailSignUp-error').removeClass('d-block').addClass('d-none');

    $.ajax({
        url: $form.data('action'),
        method: 'POST',
        data: $form.serialize(),
        success: () => {
            $('.newsletterpopin-signup').addClass('d-none');
            $before_success.addClass('d-none');
            $after_success.removeClass('d-none').addClass('isOptin');
            localStorage.setItem('optinpopin', 'cookieNewsletter');

            dataLayer.push({
                newsletter_type: 'Mail',
                event: 'newsletter_subscription',
            });
        },
        error: () => {
            // Optional error handling
        },
    });
}

// SetCookiesNewsletterOptin
function setCookiesNewsletterOptin() {
    if (localStorage.getItem("optinpopin") !== 'cookieNewsletter') {
        $('.newsletter-container').addClass('is-shown');
        $('body').addClass('lock-body');
    }

    $('.newsletter-container__close').on('click', () => {
        $('.newsletter-container').removeClass('is-shown');
        $('body').removeClass('lock-body');
        localStorage.setItem('optinpopin', 'cookieNewsletter');
    });
}

// Resets newsletter popin before form submission.
function handleNewsletterPopinBeforeSubmitForm() {
    $('.js-newsletter-us').find('#newsletterPreviewButton').on('click', function () {
        const $error_popin = $('.popin-email-signup .invalid-feedback');
        const $emailSignUpError = $('.popin-email-signup #hpEmailSignUp-error-empty');
        const $errorValidateRGPD_popin = $('#checkbox-hpEmailSignUp-popin-error');

        $error_popin.hide();
        $emailSignUpError.hide();

        const filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
        const email = $('#popinEmailSignUp').val().trim();

        if (email === '') {
            $errorValidateRGPD_popin.show();
            $error_popin.show();
            $emailSignUpError.show();
            return;
        }

        if (!filter.test(email)) {
            $error_popin.show().addClass('d-block');
            return;
        }

        if ($('#checkbok-hpEmailSignUp-popin').length === 0 || $('#checkbok-hpEmailSignUp-popin').val() === "1") {
            $errorValidateRGPD_popin.hide();
            $('.popin-email-signup #hpEmailSignUp-error, .popin-email-signup #hpPhoneSignUp-error').removeClass('d-block').addClass('d-none');

            const $parent = $(this).closest('.js-newsletter-us');
            $parent.find('.inputEmailField').addClass('d-none');
            $parent.find('.inputPhoneField').removeClass('d-none');
            $parent.find('#newsletterPreviewButton').addClass('d-none');
            $parent.find('#newsletterSubmitButton').removeClass('d-none');
        } else {
            $errorValidateRGPD_popin.show();
        }
    });
}

// Handles submission of the pop-in newsletter form
function handleNewsletterPopinSubmitForm() {
    $('.popin-email-signup #newsletterSubmitButton').on('click', function (e) {
        e.preventDefault();

        var $error_popin = $('.popin-email-signup .invalid-feedback');
        var $emailSignUpError = $('.popin-email-signup #hpEmailSignUp-error-empty');
        var $phoneSignUpError = $('.popin-email-signup #hpPhoneSignUp-error-empty');
        var $errorValidateRGPD_popin = $('#checkbox-hpEmailSignUp-popin-error');
        var $before_success = $('.popin-email-signup .newsletter-before-submit');
        var $after_success = $('.popin-email-signup .newsletter-after-submit');
        var $btn_submit = $("#newsletterPreviewButton");

        $error_popin.hide();
        $after_success.addClass('d-none');
        $emailSignUpError.hide();
        $phoneSignUpError.hide();

        var $form = $('.popin-email-signup .newsletterpopin-signup');

        var filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
        var filterPhone = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;

        var email = $('#popinEmailSignUp');
        var phone = $('#popinPhoneSignUp');

        if (email.val().trim() !== '') {
            if (!filter.test(email.val())) {
                $error_popin.show();
                $error_popin.addClass('d-block');
                email.focus();
            } else {
                if ($('#checkbok-hpEmailSignUp-popin').length === 0 || $('#checkbok-hpEmailSignUp-popin').val() === "1") {
                    if (phone.length) {
                        if (phone.val().trim() !== '') {
                            if (!filterPhone.test(phone.val())) {
                                $error_popin.show();
                                $error_popin.addClass('d-block');
                            } else {
                                successNewsletterSubscribe($form, $errorValidateRGPD_popin, $before_success, $after_success);
                            }
                        } else if (phone.val().trim() === '') {
                            $errorValidateRGPD_popin.show();
                            $error_popin.show();
                            $phoneSignUpError.show();
                        }
                    } else {
                        successNewsletterSubscribe($form, $errorValidateRGPD_popin, $before_success, $after_success);
                    }
                } else {
                    $btn_submit.removeClass('d-none');
                    $errorValidateRGPD_popin.show();
                }
            }
        } else if (email.val().trim() === '') {
            $btn_submit.removeClass('d-none');
            if ($('#checkbok-hpEmailSignUp-popin').val() === "0") {
                $errorValidateRGPD_popin.show();
            }
            $error_popin.show();
            $emailSignUpError.show();
        }

    });
}

// Add background to content Newsletter Popin
function initNewsletterPopinBackground() {
    $('.newsletter-container').each(function() {
        const bgColor = $(this).find('.newsletter-container__content').data('bgn');
        
        if (bgColor) {
            $(this).css('background-color', bgColor);
        }
    });
}

// Binds RGPD show/hide and checkbox toggles
function bindRGPDHandlers() {
    $('.rgpd-footer-more').on('click', function () {
        $(this).hide();
        $('.rgpd-footer-complete').show();
    });

    $('.rgpd-footer-less').on('click', function () {
        $('.rgpd-footer-complete').hide();
        $('.rgpd-footer-more').show();
    });

    $('#label-checkbok-hpEmailSignUp').on('click', function () {
        const checkbox = $('#checkbok-hpEmailSignUp');
        checkbox.val(checkbox.val() === "1" ? "0" : "1");
    });

    $('#label-checkbok-hpEmailSignUp-popin').on('click', function () {
        const checkbox = $('#checkbok-hpEmailSignUp-popin');
        checkbox.val(checkbox.val() === "1" ? "0" : "1");
    });
}

// Initializes all footer-related behaviors
module.exports = function () {
    initNewsletterInputFocus();
    bindEmailInputValidation();
    bindPopinEmailValidation();
    bindPopinPhoneValidation();
    handleNewsletterFormSubmit();
    setCookiesNewsletterOptin();
    handleNewsletterPopinBeforeSubmitForm();
    handleNewsletterPopinSubmitForm();
    initNewsletterPopinBackground();
    bindRGPDHandlers();
};
